/**
 * Parse a date-only string ('YYYY-MM-DD', or the date part of an ISO datetime)
 * into a Date at LOCAL midnight.
 *
 * `new Date('2026-07-10')` parses as UTC midnight, which Mantine's DatePicker
 * then renders in local time — showing the previous day for any user west of
 * UTC. The write path uses local getters (getFullYear/getMonth/getDate), so
 * parsing back as local here keeps the round-trip symmetric.
 */
export function parseLocalDate(s: string | null | undefined): Date | null {
  if (!s) return null;
  const m = s.slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}
